import { useTranslation } from "react-i18next";

/**
 * Marks text written by artificial intelligence (EU AI Act, art. 50): put it
 * next to every AI suggestion so the user knows to check it before use.
 */
export function AiBadge({ short = false }: { short?: boolean }) {
  const { t } = useTranslation();
  return (
    <span className="ai-badge" title={t("ai.badgeHint")}>
      {t(short ? "ai.badgeShort" : "ai.badge")}
    </span>
  );
}
